import React, {useMemo} from 'react';
import {t} from 'i18next';
import dayjs from 'dayjs';
import styled from 'styled-components';
import ConfirmationModal from '../ConfirmationModal';
import {FlexColumnSection, FlexRowSection, SmallText} from '../../../styles/globalStyles';
import {Colors} from '@arboxappv4/shared/src/styles/Colors';
import {DB_DATE_FORMAT} from '@arboxappv4/shared/src/constants/constants';

const LinkExistingModal = (props) => {
    const {isOpen, onClose, onConfirm, userBox, messageKey} = props;
    const canLink = messageKey === 'personal-id-exists-link-group';

    const header = useMemo(() => {
        if (!userBox) return '';
        return `${userBox.first_name || ''} ${userBox.last_name || ''}`.trim();
    }, [userBox]);

    const genderLabel = useMemo(() => {
        if (!userBox?.gender) return '-';
        return t(userBox.gender) || userBox.gender;
    }, [userBox?.gender]);

    const birthdayLabel = useMemo(() => {
        if (!userBox?.birthday) return '-';
        const parsed = dayjs(userBox.birthday, DB_DATE_FORMAT);
        return parsed.isValid() ? parsed.format('DD/MM/YYYY') : userBox.birthday;
    }, [userBox?.birthday]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={canLink ? onConfirm : undefined}
            hideSubmit={!canLink}
            header={header}
            explanation={t(canLink ? 'personal-id-link-group-popup-explain' : 'personal-id-already-in-another-group')}
            submitText={t('proceed')}
            content={
                <FlexColumnSection gap={'12px'}>
                    <DetailRow label={t('personal-id')} value={userBox?.personal_id || '-'} />
                    <DetailRow label={t('gender')} value={genderLabel} />
                    <DetailRow label={t('birth-date')} value={birthdayLabel} />
                </FlexColumnSection>
            }
        />
    );
};

const DetailRow = ({label, value}) => (
    <FlexRowSection justify={'space-between'} gap={'12px'}>
        <DetailLabel>{label}</DetailLabel>
        <DetailValue>{value}</DetailValue>
    </FlexRowSection>
);

export default LinkExistingModal;

const DetailLabel = styled(SmallText)`
    color: ${Colors.siteBlack};
    opacity: 0.7;
`;

const DetailValue = styled(SmallText)`
    font-weight: 600;
    color: ${Colors.siteBlack};
`;
